export function TermsPage() {
  return (
    <div className="min-h-screen">
      <section className="py-20 bg-[#F6F2EB]">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-6">Terms of Service</h1>
          <p className="text-muted-foreground">Last updated: April 23, 2026</p>
        </div>
      </section>

      <section className="py-12 bg-[#F6F2EB]">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold mb-4">1. Acceptance of Terms</h2>
            <p className="text-muted-foreground mb-8">
              These Terms and Conditions apply to products and services supplied by Paper Printing Services, operating under the commercial brand Colour Club Printers. References to "we," "us" and "our" mean Paper Printing Services. By accessing and using our services, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>

            <h2 className="text-3xl font-bold mb-4">2. Services</h2>
            <p className="text-muted-foreground mb-8">
              Colour Club Printers provides premium packaging and printing solutions for global brands, including design, production, and delivery of packaging materials. We are FSC certified, ISO 9001 compliant, and Sedex registered. All services are subject to availability and acceptance of orders at our discretion.
            </p>

            <h2 className="text-3xl font-bold mb-4">3. Orders and Quotes</h2>
            <ul className="list-disc pl-6 text-muted-foreground mb-8 space-y-2">
              <li>All quotes are valid for 30 days from the date of issue unless otherwise stated</li>
              <li>Quotes are subject to change based on material costs and specifications</li>
              <li>Orders are confirmed upon receipt of written acceptance and deposit payment</li>
              <li>Minimum order quantities may apply for certain products</li>
            </ul>

            <h2 className="text-3xl font-bold mb-4">4. Payment Terms</h2>
            <ul className="list-disc pl-6 text-muted-foreground mb-8 space-y-2">
              <li>Payment terms are net 30 days for approved accounts</li>
              <li>New customers may be required to pay in full before production</li>
              <li>A deposit of 50% is typically required before production begins</li>
              <li>Late payments may incur interest charges at the rate of 1.5% per month</li>
              <li>All prices are exclusive of VAT unless otherwise stated</li>
            </ul>

            <h2 className="text-3xl font-bold mb-4">5. Design and Artwork</h2>
            <p className="text-muted-foreground mb-4">
              Client responsibilities for artwork:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-8 space-y-2">
              <li>Clients are responsible for the accuracy of all artwork and copy</li>
              <li>We will provide design services at an additional cost if required</li>
              <li>Proofs must be approved in writing before production begins</li>
              <li>Changes after proof approval may incur additional charges</li>
              <li>We are not responsible for errors in client-supplied artwork</li>
            </ul>

            <h2 className="text-3xl font-bold mb-4">6. Production and Delivery</h2>
            <ul className="list-disc pl-6 text-muted-foreground mb-8 space-y-2">
              <li>Production times are estimates and not guaranteed unless expressly agreed</li>
              <li>Delivery dates are approximate and subject to factors beyond our control</li>
              <li>We are not liable for delays caused by third-party suppliers or shipping carriers</li>
              <li>Risk of loss passes to the customer upon delivery to the carrier</li>
            </ul>

            <h2 className="text-3xl font-bold mb-4">7. Quality and Specifications</h2>
            <p className="text-muted-foreground mb-8">
              We maintain strict quality control standards and are committed to delivering products that meet agreed specifications. Color variations of ±10% are considered acceptable in the printing industry due to variations in materials and printing processes.
            </p>

            <h2 className="text-3xl font-bold mb-4">8. Returns and Cancellations</h2>
            <ul className="list-disc pl-6 text-muted-foreground mb-8 space-y-2">
              <li>Custom products cannot be returned unless defective</li>
              <li>Defective products must be reported within 7 days of delivery</li>
              <li>Cancellations after production has started will incur charges for work completed</li>
              <li>We reserve the right to produce 10% over or under the ordered quantity</li>
            </ul>

            <h2 className="text-3xl font-bold mb-4">9. Intellectual Property</h2>
            <p className="text-muted-foreground mb-8">
              Clients retain ownership of their intellectual property. We retain the right to use images of completed projects for marketing purposes unless otherwise agreed in writing.
            </p>

            <h2 className="text-3xl font-bold mb-4">10. Limitation of Liability</h2>
            <p className="text-muted-foreground mb-8">
              Our liability for any claim arising from our services is limited to the invoice value of the specific order. We are not liable for consequential, indirect, or special damages.
            </p>

            <h2 className="text-3xl font-bold mb-4">11. Force Majeure</h2>
            <p className="text-muted-foreground mb-8">
              We are not liable for failure to perform our obligations due to circumstances beyond our reasonable control, including natural disasters, strikes, or government regulations.
            </p>

            <h2 className="text-3xl font-bold mb-4">12. Governing Law</h2>
            <p className="text-muted-foreground mb-8">
              These terms are governed by the laws of Pakistan. Any disputes shall be subject to the exclusive jurisdiction of the courts of Faisalabad, Pakistan.
            </p>

            <h2 className="text-3xl font-bold mb-4">13. Changes to Terms</h2>
            <p className="text-muted-foreground mb-8">
              We reserve the right to modify these terms at any time. Continued use of our services after changes constitutes acceptance of the modified terms.
            </p>

            <h2 className="text-3xl font-bold mb-4">14. Contact Information</h2>
            <div className="bg-white rounded-2xl p-6 mb-8 space-y-2 text-muted-foreground">
              <p>
                <strong>Email:</strong> info@colourclubprinters.com
              </p>
              <p>colourclubprinter@gmail.com</p>
              <p>
                <strong>Tel:</strong> +92-41-8750239
              </p>
              <p>
                <strong>Tel:</strong> +92-41-8850239
              </p>
              <p>
                <strong>Mobile:</strong> +92-300-8666239
              </p>
              <p>
                <strong>Address:</strong> Madina Market, Sugar Mor, Near PSO Pump, Sheikhupura Road, Nishatabad,
                Faisalabad, Pakistan
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
